<app-home-hero-v2 *ngIf="renderRebrandedContent" />
<app-home-hero *ngIf="!renderRebrandedContent"></app-home-hero>


<ngb-alert
  *ngIf="alert"
  [type]="alert.type"
  (closed)="closeAlert()"
  class="sticky-top"
  style="top: 10px"
>
  {{ alert.message }}
</ngb-alert>

<ng-container *ngIf="renderRebrandedContent; then rebrandedContent; else legacyContent"></ng-container>

<ng-template #rebrandedContent>
  <app-home-steps-v2 />
  <app-chip-checker-v2 />
  <app-home-update-details-v2 />
  <app-home-testimonials-v2 />
</ng-template>

<ng-template #legacyContent>
  <app-home-carousel></app-home-carousel>
  
  <div class="steps-section">
    <app-home-steps></app-home-steps>
  </div>
  
  <div class="container mt-5 mb-5">
    <div class="row">
      <div class="col-md-6 d-flex">
        <app-chip-checker [variant]="'purina'"></app-chip-checker>
      </div>
      <div class="col-md-6 mt-4 mt-md-0 d-flex">
        <div class="home-card p-3 d-flex flex-column">
          <div>
            <h3>Update your details</h3>
            <p>
              Our service relies on up-to-date information. To make changes to your profile, just log
              in or print and post our forms.
            </p>
          </div>
  
          <div class="row pt-4">
            <div class="col-sm-5 col-md-6 col-lg-5 offset-sm-7 offset-md-6 offset-lg-7">
              <a
                routerLink="/login"
                (click)="trackEvent('homepage::login::clicked')"
                class="btn btn-orange w-100"
              >
                Log in
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

